// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__hJuVY","description":"PatientConsentPreview_description__1VTWQ"};